import { render, staticRenderFns } from "./MouthRanking3.vue?vue&type=template&id=43f252fa&scoped=true"
import script from "./MouthRanking3.vue?vue&type=script&lang=js"
export * from "./MouthRanking3.vue?vue&type=script&lang=js"
import style0 from "./MouthRanking3.vue?vue&type=style&index=0&id=43f252fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f252fa",
  null
  
)

export default component.exports